import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService{

  constructor(private router:Router,private service:AuthService) {
 
  }

  canActivate():boolean{
    if(!this.service.isLoggedIn())
    {
      this.router.navigate(['/auth/login'])
      return false
    }
    return true;
  }

}


export const authGuard: CanActivateFn = (route, state) => {
  return inject(AuthGuardService).canActivate();
};
